import React from "react";
import useAuth from "../../hooks/useAuth";
import useSPPosition from "../../hooks/useSPPosition";
import useSPUndo from "../../hooks/useSPUndo";
import { handleInputSelect, addEdits } from "./utils/inputhandlers";
import SearchField from "../SearchField/SearchField";
import SPPositionFormGroup from "./SPPositionFormGroup";

const PositionsSPInCharge = ({ clearfield }) => {
  // Load context values
  const { auth } = useAuth();
  const { SPposition, setSPposition, setSPpositionData } = useSPPosition();
  const { positionEditsSP, editIDSP, setEditIDSP, undoListSP } = useSPUndo();

  // Local function to allow shorthand input property for onItemSelect
  const localHandleInputSelect = (item, origin, destination) => {
    handleInputSelect(
      item,
      positionEditsSP,
      editIDSP,
      setEditIDSP,
      setSPposition,
      setSPpositionData,
      addEdits,
      undoListSP,
      origin,
      destination
    );
  };

  return (
    <fieldset>
      <legend>In Charge:</legend>
      <div className='form-group'>
        <label>Trader:</label>
        {auth?.role === 2020 ? (
          <SearchField
            required={true}
            searchURL='/api/users/gettraderlist'
            value={SPposition?.trader || ""}
            valueName='trader'
            valueID='traderID'
            style={{ width: "90%" }}
            customplaceholder='Select TIC'
            onItemSelect={(item) => {
              localHandleInputSelect(item, "trader", "trader");
            }}
            clearfield={clearfield}
          />
        ) : (
          <SPPositionFormGroup readOnly={true} labelname={"Trader"} inputname={"trader"} />
        )}
      </div>
      <div className='form-group'>
        <label>Traffic:</label>
        <SearchField
          required={true}
          searchURL='/api/users/gettrafficlist'
          value={SPposition?.traffic || ""}
          valueName='traffic'
          valueID='trafficID'
          style={{ width: "90%" }}
          customplaceholder='Select Traffic'
          onItemSelect={(item) => {
            localHandleInputSelect(item, "traffic", "traffic");
          }}
          clearfield={clearfield}
        />
      </div>
    </fieldset>
  );
};

export default PositionsSPInCharge;
